import React, {useEffect, useRef, useState} from 'react';
import {bold, normal} from "./sussdPdfFont";
import {layoutMultilineText, PDFDocument, rgb, TextAlignment} from "pdf-lib";
import ReactDOMServer from "react-dom/server";

import fontkit from "@pdf-lib/fontkit";
import {App} from "antd";

const kevinSignature = "data:image/png;base64,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"
//const sussdImageOld = "data:image/png;base64,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"
const sussdImage = "data:image/png;base64,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"
const normalFontBytes = Uint8Array.from(atob(normal), c => c.charCodeAt(0));
const boldFontBytes = Uint8Array.from(atob(bold), c => c.charCodeAt(0));

const tickPath = 'm 5,8 q 0.510167,0 0.771791,0.837197 0.523248,1.569744 0.745628,1.569744 0.170056,0 0.353192,-0.261624 3.675818,-5.886541 6.802225,-9.523115 0.811035,-0.941846 2.576997,-0.941846 0.418598,0 0.562492,0.07849 0.143893,0.07849 0.143893,0.196218 0,0.183137 -0.43168,0.719466 -5.049344,6.069678 -9.36614,12.819578 -0.300868,0.470923 -1.229633,0.470923 -0.941847,0 -1.111902,-0.07849 -0.444761,-0.196218 -1.046496,-2.001424 -0.680223,-2.001424 -0.680223,-2.511591 0,-0.54941 0.915684,-1.059577 0.562492,-0.313949 0.994172,-0.313949 z'
const uncheckedPath = 'm 1.9105,0 h 12.289001 c 1.058417,0 1.9105,0.85208302 1.9105,1.9105 v 12.289001 c 0,1.058417 -0.852083,1.9105 -1.9105,1.9105 H 1.9105 C 0.85208302,16.110001 0,15.257918 0,14.199501 V 1.9105 C 0,0.85208302 0.85208302,0 1.9105,0 Z'
const bulletPath = 'm 2, 2 m -2, 0 a 2,2 0 1,0 4,0 a 2,2 0 1,0 -4,0'
const a4Width = 595.28; // A4 width in points
const a4Height = 841.89; // A4 height in points
function rgbToPdfLibColor(r, g, b) {
    // Normalize RGB values to range 0-1
    const normalizedR = r / 255;
    const normalizedG = g / 255;
    const normalizedB = b / 255;

    return rgb(normalizedR, normalizedG, normalizedB);
}

export const green = rgbToPdfLibColor(17, 128, 101)
export const red = rgbToPdfLibColor(212, 51, 51)
export const pink = rgbToPdfLibColor(209, 93, 207)
export const blue = rgbToPdfLibColor(14, 121, 198)
export const purple = rgbToPdfLibColor(114, 46, 209)
export const orange = rgbToPdfLibColor(238, 173, 50)
export const cyan = rgbToPdfLibColor(17, 169, 169)
export const lime = rgbToPdfLibColor(143, 167, 0)
export const lightgray = rgb(0.9, 0.9, 0.9)

export const fadedred = rgb(0.95, 0.7, 0.7)
export const mediumgray = rgb(0.82, 0.87, 0.82)
export const muted = rgb(0.55, 0.56, 0.54)
export const darkgray = rgb(0.1, 0.2, 0.1)
const brand = rgb(0.0667, 0.5020, 0.3961)
const defaultConfig = {
    "page-break-height": "infinite",
    "text-color-default": rgb(.22, .22, .22),
    "text-color-light": rgb(.42, .42, .42),
    "grid-border-color": lightgray,
    "grid-cell-padding-x": 6,
    "grid-cell-padding-y": 3,
    "page-margin-x": 20,
    "page-margin-y": 20,
    "hr-height": 2,
    "hr-color": rgb(0.95, 0.95, 0.95),
    "font-size-default": 8,
    "font-size-heading": 12,
    "paragraph-padding-y": 4,
    "bullet-spacing": 10,
    "group-gap": 10,
    backgroundColors: {
        "default": rgb(1, 1, 1),
        "blue": rgb(0.95, 0.95, 1),
        "green": rgb(0.95, 1, 0.95),
        "red": rgb(1, 0.95, 0.95),
        "pink": rgb(1, 0.95, 1),
        "orange": rgb(1, 0.95, 0.95),
        "cyan": rgb(0.95, 1, 1),
        "lime": rgb(0.95, 1, 0.95),
        "light": rgb(0.99, 0.99, 0.99),
        "shaded": rgb(0.96, 0.97, 0.99),
    },
    colors: {
        "green": green,
        "red": red,
        "pink": pink,
        "blue": blue,
        "purple": purple,
        "orange": orange,
        "cyan": cyan,
        "lime": lime,
        "faded-red": fadedred,
        "muted": muted,
    }
}

const parseValue = (value) => {
    if ([true, false].includes(value)) {
        return value
    }
    value = value.trim();
    if (!isNaN(value) && value !== '') {
        value = parseFloat(value);
    }
    return value
}

function useSussdPdfObjects(Component, componentProps) {


    const sussd = useLocalPdfGenerator()

    return {
        initialise: sussd.initialise,
        ready: sussd.ready,
        open: () => sussd.open(Component, componentProps),
        save: () => sussd.save(Component, componentProps),
    }
    // const pdfDoc = useRef()
    // const pdfForm = useRef()
    // const fontBold = useRef()
    // const fontNormal = useRef()
    // const [ready, setReady] = useState(false)
    // const app = App.useApp()
    // const initialise = async () => {
    //     pdfDoc.current = await PDFDocument.create();
    //     pdfDoc.current.registerFontkit(fontkit);
    //     fontNormal.current = await pdfDoc.current.embedFont(normalFontBytes);
    //     fontBold.current = await pdfDoc.current.embedFont(boldFontBytes);
    //     pdfForm.current = pdfDoc.current.getForm();
    //     setReady(true)
    // }
    // function domToObject(node) {
    //     const obj = {
    //         type    : node.nodeName,
    //         props   : {},
    //         children: []
    //     };
    //
    //     if (node.attributes) {
    //
    //         for (let attr of node.attributes) {
    //             if (attr.name !== 'dot') {
    //                 obj.props[attr.name] = parseValue(attr.value);
    //             }
    //             else{
    //                 obj.props[attr.name] = attr.value
    //             }
    //         }
    //     }
    //
    //     for (let child of node.childNodes) {
    //         if (child.nodeType === 3) { // text node
    //             let value = parseValue(child.nodeValue)
    //             obj.children.push(value);
    //         }
    //         else {
    //             obj.children.push(domToObject(child));
    //         }
    //     }
    //     return obj;
    // }
    // function renderComponentToObject(Component) {
    //     const htmlString = ReactDOMServer.renderToString(Component);
    //     if (!htmlString) {
    //         return null;
    //     }
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(htmlString, 'text/html');
    //     return domToObject(doc.body.firstChild);
    // }
    // const test = async () => {
    //     const result = renderComponentToObject(<Component {...componentProps} app={app}/>);
    //
    //     if (result){
    //         const config = {
    //             ...defaultConfig, ...result.props,
    //         }
    //
    //         await build(result, config)
    //         return true
    //     }
    //     return false
    // }
    // const open = async () => {
    //
    //     let success = await test()
    //     if (success) {
    //         const pdfBytes = await pdfDoc.current.save();
    //         const blob = new Blob([pdfBytes], {type: 'application/pdf'});
    //         const blobUrl = window.URL.createObjectURL(blob);
    //         window.open(blobUrl, '_blank');
    //     }
    // }
    // const save=async ()=>{
    //     let success = await test()
    //     if (success) {
    //         const pdfBytes = await pdfDoc.current.save();
    //         return new Blob([pdfBytes], {type: 'application/pdf'});
    //     }
    //     return null
    // }
    // function manualLayoutMultilineText(text, { fontSize, font, bounds }) {
    //     const words = text.split(' ');
    //     const lines = [];
    //     let currentLine = '';
    //     let lineHeight = font.heightAtSize(fontSize);
    //
    //     words.forEach(word => {
    //         const testLine = currentLine ? `${currentLine} ${word}` : word;
    //         const testLineWidth = font.widthOfTextAtSize(testLine, fontSize);
    //
    //         if (testLineWidth <= bounds.width) {
    //             currentLine = testLine;
    //         } else {
    //             lines.push({ text: currentLine, width: font.widthOfTextAtSize(currentLine, fontSize) });
    //             currentLine = word;
    //         }
    //     });
    //
    //     if (currentLine) {
    //         lines.push({ text: currentLine, width: font.widthOfTextAtSize(currentLine, fontSize) });
    //     }
    //
    //     return { lineHeight, lines };
    // }
    // async function build(doc, config) {
    //     let components = doc.children
    //     let groupGap = doc.props['group-gap'] || defaultConfig['group-gap']
    //     let height = doc.props.height
    //
    //
    //     let props = {
    //         width: a4Width - (2 * config["page-margin-x"])
    //     }
    //     const tidyStringChildren = (node)=>{
    //         if (!node.children || !node.children.length){
    //             node.children = ['']
    //         }
    //         if (node.children.length > 1){
    //             node.children = [node.children.reduce((acc, item)=>{
    //                 if (typeof item === 'string'){
    //                     return acc + item
    //                 }
    //                 if (typeof item === 'number'){
    //                     return acc + item.toString()
    //                 }
    //                 return acc + ' '
    //             },'')]
    //         }
    //     }
    //     const genBuildOutput = (node, height, width, drawingFunction) => {
    //
    //         return {
    //             height,
    //             width,
    //             draw: ({
    //                 page,
    //                 startX,
    //                 startY,
    //                 availableHeight
    //             }) => {
    //                 drawingFunction({
    //                     page,
    //                     startX,
    //                     startY,
    //                     availableHeight
    //                 })
    //             }
    //         }
    //     }
    //     const form = pdfDoc.current.getForm();
    //
    //     async function buildComponent(node, {
    //         width,
    //         ...props
    //     }) {
    //         let localProps = node.props ? node.props : {}
    //         const getLocalPadding = (name, defaultX, defaultY)=>{
    //
    //             let X = localProps.hasOwnProperty(`${name}-x`) ? localProps[`${name}-x`] : defaultX
    //             let Y = localProps.hasOwnProperty(`${name}-y`) ? localProps[`${name}-y`] : defaultY
    //             return [
    //                 localProps.hasOwnProperty(`${name}-left`) ? localProps[`${name}-left`] : X,
    //                 localProps.hasOwnProperty(`${name}-right`) ? localProps[`${name}-right`] : X,
    //                 localProps.hasOwnProperty(`${name}-top`) ? localProps[`${name}-top`] : Y,
    //                 localProps.hasOwnProperty(`${name}-bottom`) ? localProps[`${name}-bottom`] : Y
    //             ]
    //         }
    //         const builders = {
    //             textfield: ()=>{
    //                 let height = localProps.height || 14
    //                 //textField.setText('Default Text');
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     const textField = form.createTextField(localProps.name);
    //
    //                     textField.addToPage(page, {
    //                         x: startX,
    //                         y: startY - height,
    //                         width: width ,
    //                         height: height,
    //                         borderWidth: 0,
    //                         borderColor: rgb(1, 1, 1),
    //                         backgroundColor: rgb(1, 1, 1),
    //                         textColor: green,
    //                         fontSize: 8,
    //                     });
    //
    //                 })
    //             },
    //             checkbox: async ()=>{
    //                 let height = localProps.height || 8
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //
    //                     const checkbox = form.createCheckBox(localProps.name);
    //
    //                     checkbox.addToPage(page, {
    //                         x: startX, // X coordinate (from the left)
    //                         y: startY - height -2, // Y coordinate (from the bottom)
    //                         width: height, // Width of the checkbox
    //                         height: height, // Height of the checkbox
    //                         borderWidth: 0, // Border width
    //                         borderColor: rgb(1, 1, 1),
    //                         backgroundColor: rgb(1, 1, 1), // Background color (white)
    //                         checkColor: green, // Checkmark color (black)
    //                     });
    //                 })
    //             },
    //             dropdown: async ()=>{
    //                 let height = localProps.height || 14
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //
    //                     const dropdown = form.createDropdown(localProps.name)
    //                     dropdown.setOptions(localProps.options.split("|"))
    //                     dropdown.addToPage(page, {
    //                         x              : startX,
    //                         y              : startY - height,
    //                         width,
    //                         height,
    //                         borderWidth: 0,
    //                        // borderColor: rgb(1, 1, 1),
    //                        // backgroundColor: rgb(1, 1, 1),
    //                         textColor: green,
    //                     })
    //                 })
    //             },
    //             group: async () => {
    //                 let partsPromises = node.children.map((item, i) => buildComponent(item, {width}))
    //                 let result = (await Promise.all(partsPromises)).filter(v => !!v)
    //                 let height = result.reduce((acc, item) => acc + item.height, 0)
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     let pointerY = startY
    //                     result.forEach(item => {
    //                         item.draw({
    //                             page,
    //                             startX,
    //                             startY: pointerY
    //                         })
    //                         pointerY -= item.height
    //                     })
    //                 })
    //             },
    //             sentence        : async () => {
    //                 let children = node.children.filter(c => c.type === 'STRING')
    //                 let partsPromises = children.map((item, i) => buildComponent(item, {width}))
    //                 const widths = children.map((item, i) => {
    //                     let innerItem = {...item}
    //                     tidyStringChildren(innerItem)
    //                     let font = innerItem.props.fontWeight === "bold" ? fontBold.current : fontNormal.current
    //                     let size = innerItem.props["font-size"] ? innerItem.props["font-size"] : config["font-size-default"]
    //                     return font.widthOfTextAtSize(item.children[0], size)
    //                 })
    //
    //                 let result = (await Promise.all(partsPromises)).filter(v => !!v)
    //                 let height = Math.max(...result.map(r => r.height))
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     let pointerX = startX
    //                     result.forEach((item, i) => {
    //                         item.draw({
    //                             page,
    //                             startX: pointerX,
    //                             startY
    //                         })
    //                         pointerX += widths[i]
    //                     })
    //                 })
    //             },
    //             childrenAcross: async () => {
    //                 let widths = [width]
    //                 if (node.children.length > 1) {
    //                     let columns = localProps["grid-columns"] || node.children.map(c => 24 / node.children.length)
    //                     widths = columns.map(c => width * (c / 24))
    //                 }
    //
    //
    //                 let partsPromises = node.children.map((item, i) => buildComponent(item, {width: widths[i]}))
    //                 let result = (await Promise.all(partsPromises)).filter(v => !!v)
    //                 let height = Math.max(...result.map(r => r.height))
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     let pointerX = startX
    //                     result.forEach((item, i) => {
    //                         item.draw({
    //                             page,
    //                             startX: pointerX,
    //                             startY
    //                         })
    //                         pointerX += widths[i]
    //                     })
    //                 })
    //             },
    //             childrenDown  : async () => {
    //
    //                 let partsPromises = node.children.map((item, i) => buildComponent(item, {width}))
    //                 let result = (await Promise.all(partsPromises)).filter(v => !!v)
    //                 let height = result.reduce((acc, item) => acc + item.height, 0)
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     let pointerY = startY
    //                     result.forEach(item => {
    //                         item.draw({
    //                             page,
    //                             startX,
    //                             startY: pointerY
    //                         })
    //                         pointerY -= item.height
    //                     })
    //                 })
    //             },
    //             textBlock     : async () => {
    //                 let fontSize = localProps["font-size"] ? localProps["font-size"] : config["font-size-default"]
    //                 let color = localProps.color ? config.colors[localProps.color] : config["text-color-default"]
    //                 let align = localProps.align ? localProps.align : "left"
    //                 let font = localProps["font-weight"] === "bold" ? fontBold.current : fontNormal.current
    //
    //                 tidyStringChildren(node)
    //                 let {
    //                     lineHeight,
    //                     lines
    //                 } = layoutMultilineText(node.children[0].toString(), {
    //                     fontSize,
    //                     font,
    //                     bounds: {width},
    //                 })
    //                 if (lines[0].width > width) {
    //                     // sometimes the layout is off, so we try to manually layout the text
    //                     let {lines: mLines, lineHeight: mLineHeight} = manualLayoutMultilineText(node.children[0].toString(), {
    //                         fontSize,
    //                         font,
    //                         bounds: {width},
    //                     })
    //                     lineHeight = mLineHeight
    //                     lines = mLines
    //                 }
    //                 let cleanedLines = lines.filter(l => l.text !== '')
    //                 let height = lineHeight * cleanedLines.length
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     let pointerX
    //                     // cursor must move to the bottom of the text block
    //                     let pointerY = startY - lineHeight
    //                     // text is by default at the bottom of the line, so move it to center - about 3/4 of the line height
    //                     let customOffsetY = 3 * (lineHeight - fontSize) / 4
    //                     pointerY += customOffsetY
    //                     cleanedLines.forEach((line, i) => {
    //                         let contentWidth = font.widthOfTextAtSize(line.text, fontSize)
    //                         switch (align) {
    //                             case 'center':
    //                                 pointerX = (startX + (width / 2) - (contentWidth / 2))
    //                                 break
    //                             case 'right':
    //                                 pointerX = (startX + width) - contentWidth
    //                                 break
    //                             default:
    //                                 pointerX = startX
    //                         }
    //                         // let randomColors = Object.keys(config.backgroundColors)
    //                         // let randomIndex = Math.floor(Math.random() * randomColors.length)
    //                         //     page.drawRectangle(
    //                         //         {
    //                         //             x          : pointerX,
    //                         //             y          : pointerY - customOffsetY,
    //                         //             width      : width,
    //                         //             height     : lineHeight,
    //                         //             color      : config.backgroundColors[randomColors[randomIndex]],
    //                         //             borderWidth: 0
    //                         //         }
    //                         //     )
    //                         page.drawText(line.text, {
    //                             x   : pointerX,
    //                             y   : pointerY,
    //                             size: fontSize,
    //                             lineHeight,
    //                             font: font,
    //                             color,
    //                         })
    //                         pointerY -= lineHeight
    //                     })
    //                 })
    //             },
    //             header        : async () => {
    //                 let ucTitle = node.children.length ?  node.children[0].toUpperCase() : ''
    //                 // Sussd Image
    //                 const pngImageBytes = await fetch(sussdImage).then(res => res.arrayBuffer());
    //                 const image = await pdfDoc.current.embedPng(pngImageBytes);
    //                 const {
    //                     width : imageWidth,
    //                     height: imageHeight
    //                 } = image.scale(0.5);
    //                 const textWidth = fontBold.current.widthOfTextAtSize(ucTitle, config["font-size-heading"]);
    //                 const textHeight = fontBold.current.heightAtSize(config["font-size-heading"]);
    //                 return genBuildOutput(node, 65, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     //let prevY = a4Height - marginY + 5
    //                     let prevY = startY + 5
    //                     page.drawImage(image, {
    //                         x     : startX,
    //                         y     : prevY - imageHeight,
    //                         width : imageWidth,
    //                         height: imageHeight,
    //                     })
    //                     page.drawText(ucTitle, {
    //                         x    : (startX + width) - textWidth,
    //                         y    : prevY - textHeight,
    //                         size : config["font-size-heading"],
    //                         font : fontBold.current,
    //                         color: green
    //                     })
    //                     prevY -= (imageHeight + 12)
    //                     page.drawText('Mortgages', {
    //                         x    : startX,
    //                         y    : prevY,
    //                         size : config["font-size-heading"],
    //                         font : fontNormal.current,
    //                         color: green
    //                     });
    //                     prevY -= 12
    //                     page.drawText('www.sussdmortgages.ie', {
    //                         x    : startX,
    //                         y    : prevY,
    //                         size : 8,
    //                         font : fontNormal.current,
    //                         color: config["text-color-light"]
    //                     });
    //                     prevY -= 10
    //                     page.drawText('help@sussd.ie', {
    //                         x    : startX,
    //                         y    : prevY,
    //                         size : 8,
    //                         font : fontNormal.current,
    //                         color: config["text-color-light"]
    //                     });
    //                 })
    //             },
    //             kevinSignature: async () => {
    //                 const pngImageBytes = await fetch(kevinSignature).then(res => res.arrayBuffer());
    //                 const image = await pdfDoc.current.embedPng(pngImageBytes);
    //                 const {
    //                     width : imageWidth,
    //                     height: imageHeight
    //                 } = image.scale(0.3);
    //                 return genBuildOutput(node, 10, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     page.drawImage(image, {
    //                         x     : startX,
    //                         y     : startY - imageHeight,
    //                         width : imageWidth,
    //                         height: imageHeight,
    //                     })
    //                 })
    //             },
    //             border        : async () => {
    //                 let h = localProps.height ? localProps.height : config["hr-height"]
    //                 let c = config["hr-color"]
    //                 if (localProps.color) {
    //                     c = config.colors[localProps.color]
    //                 }
    //                 return genBuildOutput(node, h, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     page.drawRectangle({
    //                         x          : startX,
    //                         y          : startY - h,
    //                         width      : width,
    //                         height     : h,
    //                         color      : c,
    //                         borderWidth: 0
    //                     })
    //                 })
    //             },
    //             container     : async () => {
    //                 let [paddingLeft, paddingRight, paddingTop, paddingBottom] = getLocalPadding('padding', 0, 0)
    //
    //                 let vAlign = localProps["v-align"] ? localProps["v-align"] : "top"
    //                 let bgColorName = localProps["bg-color"] ? localProps["bg-color"] : false
    //                 let bgColor = bgColorName ? config.backgroundColors[bgColorName] : false
    //                 let contentWidth = width - (paddingLeft + paddingRight)
    //                 if (typeof node.children === "string") {
    //                     node.children = [node.children]
    //
    //                 }
    //                 let partsPromises = node.children.map(item => buildComponent(item, {width: contentWidth}))
    //                 let result = (await Promise.all(partsPromises)).filter(v => !!v)
    //                 let contentHeight = result.reduce((acc, item) => acc + item.height, 0)
    //                 let height = contentHeight + paddingTop + paddingBottom
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     if (bgColor) {
    //                         page.drawRectangle({
    //                             x          : startX,
    //                             y          : startY - height,
    //                             width,
    //                             height     : height,
    //                             color      : bgColor,
    //                             borderWidth: 0,
    //                         })
    //                     }
    //                     result.forEach(item => {
    //                         item.draw({
    //                             page,
    //                             startX: startX + paddingLeft,
    //                             startY: startY - paddingTop
    //                         })
    //                         startY -= item.height
    //                     })
    //                 })
    //             },
    //             bullet        : async () => {
    //                 let bulletSpacing = localProps["offset"] ? localProps["offset"] : config["bullet-spacing"]
    //                 let bulletSize = localProps["size"] ? localProps["size"] : 1
    //                 let bulletColor = localProps['bullet-color'] ? config.colors[localProps['bullet-color']] : localProps["color"] ? localProps["color"] : config["text-color-default"]
    //                 let {dot, offset, color, ...rest} = localProps
    //                 let textNode = {
    //                     type    : "CONTAINER",
    //                     props   : {
    //                         "padding-left": bulletSpacing,
    //                     },
    //                     children: node.children
    //                 }
    //                 const {
    //                     height,
    //                     draw
    //                 } = await buildComponent(textNode, {width})
    //
    //                 let customDotDraw
    //                 if (localProps.dot){
    //                     let dotNode = {
    //                         "type"    : "CONTAINER",
    //                         "props"   : {},
    //                         "children": [
    //                             {
    //                                 type     : "STRING",
    //                                 props    : {
    //                                     ...localProps,
    //                                     fontWeight: 'bold',
    //                                     "padding-left":0
    //                                 },
    //                                 children : [localProps.dot.toString()]
    //                             }
    //                         ]
    //                     }
    //                     let {
    //                         height: dotHeight,
    //                         draw: customDotDrawFunction
    //                     } = await buildComponent(dotNode, {width})
    //                     customDotDraw = customDotDrawFunction
    //                 }
    //                 let bulletHeight = 4 * bulletSize
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     draw({
    //                         page,
    //                         startX,
    //                         startY
    //                     })
    //                     if (localProps.dot){
    //                         customDotDraw({ page,
    //                             startX,
    //                             startY
    //                         })
    //                     }
    //                     else{
    //                         page.drawSvgPath(bulletPath, {
    //                             x    : startX,
    //                             y    : startY - 5,
    //                             color: bulletColor,
    //                             scale: bulletSize
    //                         })
    //                     }
    //
    //                 })
    //
    //                 // let fontSize = localProps["font-size"] ? localProps["font-size"] : config["font-size-default"]
    //                 // let scale = localProps["scale"] ? localProps["scale"] : 1
    //                 // let bulletColumnWidth = localProps["bullet-spacing"] ? localProps["bullet-spacing"] : config["bullet-spacing"]
    //                 // let restColumnWidth = width - bulletColumnWidth
    //                 // let font = localProps.fontWeight === "bold" ? fontBold.current : fontNormal.current
    //                 //
    //                 // const {
    //                 //     lineHeight,
    //                 //     lines
    //                 // } = layoutMultilineText(node.children[0], {
    //                 //     fontSize,
    //                 //     font,
    //                 //     bounds: {width},
    //                 // })
    //                 // let cleanedLines = lines.filter(l => l.text !== '')
    //                 // let height = lineHeight * cleanedLines.length
    //                 //
    //                 //
    //                 // return genBuildOutput(node, fontSize * 1.5, width, ({
    //                 //     page,
    //                 //     startX,
    //                 //     startY
    //                 // }) => {
    //                 //     let bulletY = startY - (lineHeight / 2)
    //                 //     page.drawSvgPath(bulletPath, {
    //                 //         x    : startX,
    //                 //         y    : bulletY,
    //                 //         color: color,
    //                 //         scale: scale
    //                 //     })
    //                 //     let pointerY = startY
    //                 //     let customOffsetY = 3 * (lineHeight - fontSize) / 4
    //                 //     pointerY += customOffsetY
    //                 //     cleanedLines.forEach((line, i) => {
    //                 //         let contentWidth = font.widthOfTextAtSize(line.text, fontSize)
    //                 //         switch (align) {
    //                 //             case 'center':
    //                 //                 pointerX = (startX + (width / 2) - (contentWidth / 2))
    //                 //                 break
    //                 //             case 'right':
    //                 //                 pointerX = (startX + width) - contentWidth
    //                 //                 break
    //                 //             default:
    //                 //                 pointerX = startX
    //                 //         }
    //                 //         // let randomColors = Object.keys(config.backgroundColors)
    //                 //         // let randomIndex = Math.floor(Math.random() * randomColors.length)
    //                 //         //     page.drawRectangle(
    //                 //         //         {
    //                 //         //             x          : pointerX,
    //                 //         //             y          : pointerY - customOffsetY,
    //                 //         //             width      : width,
    //                 //         //             height     : lineHeight,
    //                 //         //             color      : config.backgroundColors[randomColors[randomIndex]],
    //                 //         //             borderWidth: 0
    //                 //         //         }
    //                 //         //     )
    //                 //         page.drawText(line.text, {
    //                 //             x   : startX + bulletColumnWidth,
    //                 //             y   : pointerY,
    //                 //             size: fontSize,
    //                 //             lineHeight,
    //                 //             font: font,
    //                 //             color,
    //                 //         })
    //                 //         pointerY -= lineHeight
    //                 //     })
    //                 // })
    //                 // let cell1 = gridCell({type: 'bullet'}, props)
    //                 // let cell2 = gridCell(content, {
    //                 //     ...props,
    //                 //     width: restColumnWidth
    //                 // })
    //                 //
    //                 // let builtCellsPromises = [
    //                 //     cell1,
    //                 //     cell2
    //                 // ].map((cell, i) => {
    //                 //     return buildContent(cell)
    //                 // })
    //                 // let builtCells = await Promise.all(builtCellsPromises)
    //                 //
    //                 // let rowHeight = 0
    //                 // builtCells.forEach(cell => {
    //                 //     rowHeight = Math.max(rowHeight, cell.height)
    //                 // })
    //                 // return {
    //                 //     height: rowHeight,
    //                 //     draw  : ({
    //                 //         page,
    //                 //         startX,
    //                 //         startY
    //                 //     }) => {
    //                 //         //TODO: depreciate gridInGrid
    //                 //         let rowXCursor = startX
    //                 //         builtCells.forEach((cell, i) => {
    //                 //             const {draw} = cell
    //                 //             draw({
    //                 //                 page,
    //                 //                 startX: rowXCursor,
    //                 //                 startY,
    //                 //                 height: rowHeight
    //                 //             })
    //                 //             rowXCursor += bulletColumnWidth
    //                 //         })
    //                 //     }
    //                 // }
    //                 //
    //                 // let bulletSize = fontSize * 0.5
    //                 // let lineHeight = fontSize * 1.5
    //                 // let text = node.children[0]
    //                 // let textWidth = fontNormal.current.widthOfTextAtSize(text, fontSize)
    //                 // let textHeight = fontNormal.current.heightAtSize(fontSize)
    //                 // let bulletX = 0
    //                 // let bulletY = 0
    //                 // let bulletPath = dot === 'check' ? tickPath : uncheckedPath
    //                 // return {
    //                 //     height: lineHeight,
    //                 //     draw  : ({
    //                 //         page,
    //                 //         startX,
    //                 //         startY
    //                 //     }) => {
    //                 //         bulletY = startY - (lineHeight / 2)
    //                 //         bulletX = startX
    //                 //         page.drawSvgPath(bulletPath, {
    //                 //             x    : bulletX,
    //                 //             y    : bulletY,
    //                 //             color: color,
    //                 //             scale: bulletSize
    //                 //         })
    //                 //         page.drawText(text, {
    //                 //             x    : bulletX + bulletSize + 5,
    //                 //             y    : bulletY - (textHeight / 2),
    //                 //             size : fontSize,
    //                 //             font : fontNormal.current,
    //                 //             color: color
    //                 //         })
    //                 //     }
    //                 // }
    //             },
    //             row           : async () => {
    //
    //                 localProps["grid-columns"] = props.columns
    //                 let [paddingLeft, paddingRight, paddingTop, paddingBottom] = props.cellPadding
    //                 node.children.forEach((child, i) => {
    //                     child.props["padding-left"] = child.props["padding-left"] ? child.props["padding-left"] :  paddingLeft
    //                     child.props["padding-right"] = child.props["padding-right"] ? child.props["padding-right"]:  paddingRight
    //                     child.props["padding-top"] =  child.props["padding-top"] ? child.props["padding-top"] : paddingTop
    //                     child.props["padding-bottom"] =  child.props["padding-bottom"] ?  child.props["padding-bottom"]: paddingBottom
    //                 })
    //
    //                 let {
    //                     height,
    //                     draw
    //                 } = await builders.childrenAcross()
    //                 let bgColor = localProps["bg-color"] ? config.backgroundColors[localProps["bg-color"]] : false
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     if (bgColor) {
    //                         page.drawRectangle({
    //                             x          : startX,
    //                             y          : startY - height,
    //                             width,
    //                             height     : height,
    //                             color      : bgColor,
    //                             borderWidth: 0,
    //                         })
    //                     }
    //                     draw({
    //                         page,
    //                         startX,
    //                         startY,
    //                         availableHeight: height
    //                     })
    //                 })
    //             },
    //             gridChildren  : async () => {
    //                 // row factory
    //                 let vBars = localProps["vertical-bars"] ? localProps["vertical-bars"] : false
    //                 let hBars = localProps["horizontal-bars"] ? localProps["horizontal-bars"] : false
    //                 let [left,right,top, bottom] = getLocalPadding('cell-padding', config["grid-cell-padding-x"],config["grid-cell-padding-y"])
    //
    //                 let cellPadding = [left,right,top,bottom]
    //                 let columns = [24]
    //                 if (localProps["columns"]){
    //                     if (typeof localProps["columns"] === "string"){
    //                         columns = localProps["columns"].split(/[^0-9.]+/).map(c => parseFloat(c))
    //                     }
    //                     if (Array.isArray(localProps["columns"])){
    //                         columns = localProps["columns"]
    //                     }
    //                 }
    //
    //                 // will build a row
    //                 let partsPromises = node.children.map((item, i) => buildComponent(item, {
    //                     width,
    //                     columns,
    //                     cellPadding
    //                 }))
    //                 let result = (await Promise.all(partsPromises)).filter(v => !!v)
    //
    //                 let height = result.reduce((acc, item) => acc + item.height, 0)
    //
    //                 let thickness = 0.5
    //
    //
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     let pointerY = startY
    //                     result.forEach(item => {
    //                         item.draw({
    //                             page,
    //                             startX,
    //                             startY: pointerY
    //                         })
    //                         pointerY -= item.height
    //                     })
    //                     if (vBars) {
    //                         let pointerX = startX
    //                         if (vBars !== false){
    //                             page.drawLine({
    //                                 start: {x: pointerX + (thickness/2), y: startY},
    //                                 end  : {x: pointerX + (thickness/2), y: startY - height},
    //                                 thickness,
    //                                 color: config["grid-border-color"]
    //                             })
    //                         }
    //                         columns.forEach((c, i) => {
    //                             let lastCol = i === columns.length - 1
    //                             let finalCellAdjustment = lastCol ? thickness / 2 : 0
    //                             pointerX += (c / 24) * width
    //                             if (vBars) {
    //                                 if (lastCol || vBars==="inside"){
    //                                     page.drawLine({
    //                                         start    : {
    //                                             x: pointerX - finalCellAdjustment,
    //                                             y: startY
    //                                         },
    //                                         end      : {
    //                                             x: pointerX - finalCellAdjustment,
    //                                             y: startY - height
    //                                         },
    //                                         thickness: 0.5,
    //                                         color    : config["grid-border-color"]
    //                                     })
    //                                 }
    //                             }
    //                         })
    //                     }
    //                     if (hBars) {
    //                         let pointerY = startY
    //                         page.drawLine({
    //                             start: {x: startX, y: pointerY - (thickness/2)},
    //                             end  : {x: startX + width, y: pointerY - (thickness/2)},
    //                             thickness,
    //                             color: config["grid-border-color"]
    //                         })
    //                         result.forEach((item, i) => {
    //                             pointerY -= item.height
    //                             page.drawLine({
    //                                 start: {x: startX, y: pointerY + (thickness/2)},
    //                                 end  : {x: startX + width, y: pointerY + (thickness/2)},
    //                                 thickness,
    //                                 color: config["grid-border-color"]
    //                             })
    //                         })
    //                     }
    //                 })
    //             },
    //             grid          : async () => {
    //                 let {
    //                     height,
    //                     draw
    //                 } = await builders.gridChildren() // build rows in downward direction
    //
    //                 return genBuildOutput(node, height, width, ({
    //                     page,
    //                     startX,
    //                     startY
    //                 }) => {
    //                     draw({
    //                         page,
    //                         startX,
    //                         startY
    //                     })
    //                 })
    //             },
    //             gap: async () => {
    //                 let size = localProps.size || 10
    //                 return genBuildOutput(node, size, width, () => {})
    //             }
    //         }
    //         if (typeof node === "string") {
    //             node = {
    //                 children: [node]
    //             }
    //             return await builders.textBlock()
    //         }
    //         switch (node.type.toLowerCase()) {
    //             case 'dropdown':
    //                 return await builders.dropdown()
    //             case 'checkbox':
    //                 return await builders.checkbox()
    //             case 'textfield':
    //                 return await builders.textfield()
    //             case 'kevinsignature':
    //                 return await builders.kevinSignature()
    //             case 'group':
    //                 return await builders.group()
    //             case 'sentence':
    //                 return await builders.sentence()
    //             case 'gap':
    //                 return await builders.gap()
    //             case 'string':
    //                 return builders.textBlock()
    //             case 'header':
    //                 return await builders.header()
    //             case 'border':
    //                 return await builders.border()
    //             case 'container':
    //                 return await builders.container()
    //             case 'bullet':
    //                 return await builders.bullet()
    //             case 'grid':
    //                 return await builders.grid()
    //             // return buildGrid(children, props)
    //             case 'row':
    //                 return await builders.row()
    //             case 'cell':
    //                 return await builders.container()
    //             //return buildCell(children, props)
    //             case 'p':
    //                 localProps["padding-y"] = localProps["padding-y"] && localProps["padding-y"] !== 0 ? localProps["padding-y"] : config["paragraph-padding-y"]
    //                 return await builders.container()
    //             // return buildBullet(children, props)
    //             default:
    //                 return null
    //         }
    //
    //     }
    //
    //     async function addFooter(page) {
    //         let fontSize = 7
    //         let color =  config["text-color-light"]
    //         let width = a4Width
    //         let font = fontNormal.current
    //         let string1 = 'Truss Mortgages Limited t/a Suss’d Mortgages, Company Registration Number 690100, is regulated by the Central Bank of Ireland'
    //         let string2 = 'Registered Address: 20 Harcourt Street, Dublin 2. Director: Kevin Coakley'
    //         let content1Width = font.widthOfTextAtSize(string1, fontSize)
    //         let content2Width = font.widthOfTextAtSize(string2, fontSize)
    //         let pointer1X =(startX + (width / 2) - (content1Width / 2))
    //         let pointer2X =(startX + (width / 2) - (content2Width / 2))
    //         let pointer1Y = 14
    //         let pointer2Y = 5
    //         page.drawText(string1, {
    //             x   : pointer1X,
    //             y   : pointer1Y,
    //             size: fontSize,
    //             font: font,
    //             color,
    //         })
    //         page.drawText(string2, {
    //             x   : pointer2X,
    //             y   : pointer2Y,
    //             size: fontSize,
    //             font: font,
    //             color,
    //         })
    //     }
    //     let pageComponents = (await Promise.all(components.map(item => buildComponent(item, props)))).filter(v => !!v)
    //
    //     let totalHeight = pageComponents.reduce((acc, component) => acc + component.height, 0) + (2 * config["page-margin-y"])
    //
    //     totalHeight += (pageComponents.length - 1) * groupGap
    //
    //     let startX = config["page-margin-x"]
    //     if (height === "infinite") {
    //
    //         let startY = totalHeight - config["page-margin-y"]
    //         const pageInfinite = pdfDoc.current.addPage([
    //             a4Width,
    //             totalHeight
    //         ]);
    //         pageComponents.forEach(component => {
    //             component.draw({
    //                 page: pageInfinite,
    //                 startY,
    //                 startX
    //             })
    //             startY -= component.height + groupGap
    //         })
    //         await addFooter(pageInfinite)
    //
    //
    //     }
    //     else {
    //
    //         const newPage = ()=>{
    //             let pg =  pdfDoc.current.addPage([
    //                 a4Width,
    //                 a4Height
    //             ])
    //             addFooter(pg)
    //             return pg
    //         }
    //         let startY = a4Height - config["page-margin-y"]
    //         let maxHeight = a4Height - (2 * config["page-margin-y"])
    //
    //         while (pageComponents.length){
    //             let page = newPage();
    //             let myY = startY
    //             let currentPageGroupsHeight = 0
    //             while (pageComponents.length){
    //                 let nextComponent = pageComponents[0]
    //                 let spaceNeeded = groupGap + nextComponent.height
    //                 // if space available add the group to the page and remove it from the list of pageComponents
    //                 if (currentPageGroupsHeight + spaceNeeded < maxHeight){
    //
    //                     let currentComponent = pageComponents.shift()
    //                     currentComponent.draw({
    //                         page,
    //                         startY: myY,
    //                         startX
    //                     })
    //                     currentPageGroupsHeight += spaceNeeded
    //                     myY -= spaceNeeded
    //                 }
    //                 else{

    //                     break
    //                 }
    //             }
    //         }
    //     }
    // }
    // useEffect(() => {
    //     initialise()
    //     return ()=>{
    //         pdfDoc.current = null
    //         pdfForm.current = null
    //         fontBold.current = null
    //         fontNormal.current = null
    //     }
    // }, []);
    //
    // return {
    //     ready,
    //     open,
    //     test,
    //     save,
    // }
}

export default useSussdPdfObjects;

function useSussdPdfObjectsACNCient(options) {
    function convert(PdfComponent) {
        function domToObject(node) {
            const obj = {
                type: node.nodeName,
                props: {},
                children: []
            };

            if (node.attributes) {
                for (let attr of node.attributes) {
                    obj.props[attr.name] = attr.value;
                }
            }

            for (let child of node.childNodes) {
                if (child.nodeType === 3) { // text node
                    obj.children.push(child.nodeValue);
                } else {
                    obj.children.push(domToObject(child));
                }
            }

            return obj;
        }

        function renderComponentToObject(Component) {
            const htmlString = ReactDOMServer.renderToString(Component);
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            return domToObject(doc.body.firstChild);
        }

        return renderComponentToObject(<PdfComponent/>);
    }

    function Pdf({title}) {
        return title
    }

    function Header({title}) {
        return title
    }

    function Border({
                        color,
                        height
                    }) {
        return {
            type: 'border',
            props: {
                color,
                height
            }
        }
    }

    function Container({
                           children,
                           paddingX,
                           paddingY,
                           paddingTop,
                           paddingBottom,
                           paddingLeft,
                           paddingRight
                       }) {

    }

    function String({
                        children,
                        color,
                        size,
                        weight
                    }) {

    }

    function Grid({
                      children,
                      layout
                  }) {

    }

    function Row({children}) {

    }

    function Cell({children}) {

    }

    function Bullet({
                        children,
                        dot
                    }) {

    }

    return {
        Pdf,
        Header,
        Border,
        Container,
        String,
        Grid,
        Row,
        Cell,
        Bullet,
        convert
    }
}

export function useLocalPdfGenerator() {
    const [ready, setReady] = useState(false);
    const pdfDoc = useRef()
    const pdfForm = useRef()
    const fontBold = useRef()
    const fontNormal = useRef()
    const fontHelvetica = useRef()
    const app = App.useApp()
    const initialise = async () => {
        pdfDoc.current = await PDFDocument.create();
        pdfDoc.current.registerFontkit(fontkit);
        fontNormal.current = await pdfDoc.current.embedFont(normalFontBytes, { subset: true });
        fontBold.current = await pdfDoc.current.embedFont(boldFontBytes,  { subset: true });

        //fontHelvetica.current = await pdfDoc.current.embedFont(StandardFonts.Helvetica);
        pdfForm.current = pdfDoc.current.getForm();
        // const promises = [
        //     fetch('/Manrope-Regular.ttf').then(res => res.arrayBuffer()),
        //     fetch('/Manrope-SemiBold.ttf').then(res => res.arrayBuffer()),
        // ]
        // const [ rubikFontBytes, rubikBoldFontBytes ] = await Promise.all(promises)
        // fontNormal.current = await pdfDoc.current.embedFont(rubikFontBytes);
        // fontBold.current = await pdfDoc.current.embedFont(rubikBoldFontBytes);
        setReady(true);
    }

    function domToObject(node) {
        const obj = {
            type: node.nodeName,
            props: {},
            children: []
        };

        if (node.attributes) {

            for (let attr of node.attributes) {
                if (attr.name !== 'dot') {
                    obj.props[attr.name] = parseValue(attr.value);
                } else {
                    obj.props[attr.name] = attr.value
                }
            }
        }

        for (let child of node.childNodes) {
            if (child.nodeType === 3) { // text node
                let value = parseValue(child.nodeValue)
                obj.children.push(value);
            } else {
                obj.children.push(domToObject(child));
            }
        }
        return obj;
    }

    function renderComponentToObject(Component) {

        const htmlString = ReactDOMServer.renderToString(Component);

        if (!htmlString) {
            return null;
        }
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        return domToObject(doc.body.firstChild);
    }

    const test = async (Component, componentProps) => {
        await initialise()

        const result = renderComponentToObject(<Component {...componentProps} app={app}/>);

        if (result) {
            const config = {
                ...defaultConfig, ...result.props,
            }
            await build(result, config)
            return true
        }
        return false
    }
    const open = async (Component, componentProps) => {
        let success = await test(Component, componentProps)

        if (success) {
            const pdfBytes = await pdfDoc.current.save();
            const blob = new Blob([pdfBytes], {type: 'application/pdf'});
            const blobUrl = window.URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        }
    }
    const save = async (Component, componentProps, name) => {
        let success = await test(Component, componentProps)

        if (success) {
            const pdfBytes = await pdfDoc.current.save();
            const file = new File([pdfBytes], `${name}.pdf`, {
                type: 'application/pdf',
                lastModified: Date.now()
            });
            return file
        }
        return null
    }

    function manualLayoutMultilineText(text, {fontSize, font, bounds}) {
        const words = text.split(' ');
        const lines = [];
        let currentLine = '';
        let lineHeight = font.heightAtSize(fontSize);

        words.forEach(word => {
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            const testLineWidth = font.widthOfTextAtSize(testLine, fontSize);

            if (testLineWidth <= bounds.width) {
                currentLine = testLine;
            } else {
                lines.push({text: currentLine, width: font.widthOfTextAtSize(currentLine, fontSize)});
                currentLine = word;
            }
        });

        if (currentLine) {
            lines.push({text: currentLine, width: font.widthOfTextAtSize(currentLine, fontSize)});
        }

        return {lineHeight, lines};
    }

    async function build(doc, config) {
        let components = doc.children
        let groupGap = doc.props['group-gap'] || defaultConfig['group-gap']
        let height = doc.props.height


        let props = {
            width: a4Width - (2 * config["page-margin-x"])
        }
        const tidyStringChildren = (node) => {
            if (!node.children || !node.children.length) {
                node.children = ['']
            }
            if (node.children.length > 1) {
                node.children = [node.children.reduce((acc, item) => {
                    if (typeof item === 'string') {
                        return acc + item
                    }
                    if (typeof item === 'number') {
                        return acc + item.toString()
                    }
                    return acc + ' '
                }, '')]
            }
        }
        const genBuildOutput = (node, height, width, drawingFunction) => {

            return {
                height,
                width,
                draw: ({
                           page,
                           startX,
                           startY,
                           availableHeight
                       }) => {
                    drawingFunction({
                        page,
                        startX,
                        startY,
                        availableHeight
                    })
                }
            }
        }
        const form = pdfDoc.current.getForm();

        async function buildComponent(node, {
            width,
            ...props
        }) {
            let localProps = node.props ? node.props : {}
            const getLocalPadding = (name, defaultX, defaultY) => {

                let X = localProps.hasOwnProperty(`${name}-x`) ? localProps[`${name}-x`] : defaultX
                let Y = localProps.hasOwnProperty(`${name}-y`) ? localProps[`${name}-y`] : defaultY
                return [
                    localProps.hasOwnProperty(`${name}-left`) ? localProps[`${name}-left`] : X,
                    localProps.hasOwnProperty(`${name}-right`) ? localProps[`${name}-right`] : X,
                    localProps.hasOwnProperty(`${name}-top`) ? localProps[`${name}-top`] : Y,
                    localProps.hasOwnProperty(`${name}-bottom`) ? localProps[`${name}-bottom`] : Y
                ]
            }
            const builders = {
                textfield: () => {
                    let height = localProps.height || 14
                    // if (localProps?.multiline){
                    //     height= height * localProps.multiline
                    // }
                    //textField.setText('Default Text');
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        const textField = form.createTextField(localProps.name);
                        if (localProps?.multiline) {
                            textField.enableMultiline()
                        }
                        if (localProps?.align === "right") {
                            textField.setAlignment(TextAlignment.Right)
                        } else if (localProps?.align === "center") {
                            textField.setAlignment(TextAlignment.Center)
                        }

                        textField.addToPage(page, {
                            x: startX,
                            y: startY - height,
                            width: width,
                            height: height,
                            borderWidth: 0,
                            size: localProps["font-size"] || config["font-size-default"],
                            fontSize: localProps["font-size"] ||  config["font-size-default"],
                        });

                    })
                },
                checkbox: async () => {
                    let height = localProps.height || 8
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {

                        const checkbox = form.createCheckBox(localProps.name);

                        checkbox.addToPage(page, {
                            x: startX, // X coordinate (from the left)
                            y: startY - height - 2, // Y coordinate (from the bottom)
                            width: height, // Width of the checkbox
                            height: height, // Height of the checkbox
                            borderWidth: 0, // Border width
                            borderColor: rgb(1, 1, 1),
                            backgroundColor: rgb(1, 1, 1), // Background color (white)
                            checkColor: green, // Checkmark color (black)
                        });
                    })
                },
                dropdown: async () => {
                    let height = localProps.height || 14
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {

                        const dropdown = form.createDropdown(localProps.name)
                        dropdown.setOptions(localProps.options.split("|"))
                        dropdown.addToPage(page, {
                            x: startX,
                            y: startY - height,
                            width,
                            height,
                            borderWidth: 0,
                            // borderColor: rgb(1, 1, 1),
                            // backgroundColor: rgb(1, 1, 1),
                            textColor: green,
                        })
                    })
                },
                radio: async () => {
                    let height = localProps.height || 14
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {

                        const radioGroup = form.createRadioGroup(localProps.name)

                        let x = startX
                        let y = startY - height
                        if (localProps?.grid) {

                        }
                        let font = fontNormal.current
                        let fontSize = localProps["font-size"] ? localProps["font-size"] : config["font-size-default"]
                        let {
                            lineHeight
                        } = layoutMultilineText("abc", {
                            fontSize,
                            font,
                            bounds: {width},
                        })
                        let customOffsetY = 3 * (lineHeight - fontSize) / 4

                        localProps.options.split("|").forEach((option, i) => {
                            radioGroup.addOptionToPage(`${localProps.name}_${option}`, page, {
                                y,
                                x,
                                width: height,
                                height: height,
                                color: green
                            })
                            x += 18
                            page.drawText(option, {
                                x,
                                y: y + customOffsetY,
                                size: fontSize,
                                lineHeight,
                                font: font,
                            })
                            let optWidth = font.widthOfTextAtSize(option, fontSize)
                            x += optWidth + 10
                        })

                    })
                },
                group: async () => {
                    let partsPromises = node.children.map((item, i) => buildComponent(item, {width}))
                    let result = (await Promise.all(partsPromises)).filter(v => !!v)
                    let height = result.reduce((acc, item) => acc + item.height, 0)
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        let pointerY = startY
                        result.forEach(item => {
                            item.draw({
                                page,
                                startX,
                                startY: pointerY
                            })
                            pointerY -= item.height
                        })
                    })
                },
                sentence: async () => {
                    let children = node.children.filter(c => c.type === 'STRING')
                    let partsPromises = children.map((item, i) => buildComponent(item, {width}))
                    const widths = children.map((item, i) => {
                        let innerItem = {...item}
                        tidyStringChildren(innerItem)
                        let font = innerItem.props.fontWeight === "bold" ? fontBold.current : fontNormal.current
                        let size = innerItem.props["font-size"] ? innerItem.props["font-size"] : config["font-size-default"]
                        return font.widthOfTextAtSize(item.children[0], size)
                    })

                    let result = (await Promise.all(partsPromises)).filter(v => !!v)
                    let height = Math.max(...result.map(r => r.height))
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        let pointerX = startX
                        result.forEach((item, i) => {
                            item.draw({
                                page,
                                startX: pointerX,
                                startY
                            })
                            pointerX += widths[i]
                        })
                    })
                },
                childrenAcross: async () => {
                    let widths = [width]
                    if (node.children.length > 1) {
                        let columns = localProps["grid-columns"] || node.children.map(c => 24 / node.children.length)
                        widths = columns.map(c => width * (c / 24))
                    }


                    let partsPromises = node.children.map((item, i) => buildComponent(item, {width: widths[i]}))
                    let result = (await Promise.all(partsPromises)).filter(v => !!v)
                    let height = Math.max(...result.map(r => r.height))
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        let pointerX = startX
                        result.forEach((item, i) => {
                            item.draw({
                                page,
                                startX: pointerX,
                                startY
                            })
                            pointerX += widths[i]
                        })
                    })
                },
                childrenDown: async () => {

                    let partsPromises = node.children.map((item, i) => buildComponent(item, {width}))
                    let result = (await Promise.all(partsPromises)).filter(v => !!v)
                    let height = result.reduce((acc, item) => acc + item.height, 0)
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        let pointerY = startY
                        result.forEach(item => {
                            item.draw({
                                page,
                                startX,
                                startY: pointerY
                            })
                            pointerY -= item.height
                        })
                    })
                },
                textBlock: async () => {
                    let fontSize = localProps["font-size"] ? localProps["font-size"] : config["font-size-default"]

                    let color = localProps.color ? config.colors[localProps.color] : config["text-color-default"]
                    let align = localProps.align ? localProps.align : "left"
                    let font = localProps["font-weight"] === "bold" ? fontBold.current : fontNormal.current

                    tidyStringChildren(node)
                    let {
                        lineHeight,
                        lines
                    } = layoutMultilineText(node.children[0].toString(), {
                        fontSize,
                        font,
                        bounds: {width},
                    })
                    if (lines[0].width > width) {
                        // sometimes the layout is off, so we try to manually layout the text
                        let {
                            lines: mLines,
                            lineHeight: mLineHeight
                        } = manualLayoutMultilineText(node.children[0].toString(), {
                            fontSize,
                            font,
                            bounds: {width},
                        })
                        lineHeight = mLineHeight
                        lines = mLines
                    }
                    let cleanedLines = lines.filter(l => l.text !== '')
                    let height = lineHeight * cleanedLines.length
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        let pointerX
                        // cursor must move to the bottom of the text block
                        let pointerY = startY - lineHeight
                        // text is by default at the bottom of the line, so move it to center - about 3/4 of the line height
                        let customOffsetY = 3 * (lineHeight - fontSize) / 4
                        pointerY += customOffsetY
                        cleanedLines.forEach((line, i) => {
                            let contentWidth = font.widthOfTextAtSize(line.text, fontSize)
                            switch (align) {
                                case 'center':
                                    pointerX = (startX + (width / 2) - (contentWidth / 2))
                                    break
                                case 'right':
                                    pointerX = (startX + width) - contentWidth
                                    break
                                default:
                                    pointerX = startX
                            }
                            // let randomColors = Object.keys(config.backgroundColors)
                            // let randomIndex = Math.floor(Math.random() * randomColors.length)
                            //     page.drawRectangle(
                            //         {
                            //             x          : pointerX,
                            //             y          : pointerY - customOffsetY,
                            //             width      : width,
                            //             height     : lineHeight,
                            //             color      : config.backgroundColors[randomColors[randomIndex]],
                            //             borderWidth: 0
                            //         }
                            //     )
                            page.drawText(line.text, {
                                x: pointerX,
                                y: pointerY,
                                size: fontSize,
                                lineHeight,
                                font: font,
                                color,
                            })
                            pointerY -= lineHeight
                        })
                    })
                },
                header: async () => {
                    let ucTitle = node.children.length ? node.children[0].toUpperCase() : ''
                    // Sussd Image
                    const pngImageBytes = await fetch(sussdImage).then(res => res.arrayBuffer());
                    const image = await pdfDoc.current.embedPng(pngImageBytes);
                    const {
                        width: imageWidth,
                        height: imageHeight
                    } = image.scale(0.5);
                    const textWidth = fontBold.current.widthOfTextAtSize(ucTitle, config["font-size-heading"]);
                    const textHeight = fontBold.current.heightAtSize(config["font-size-heading"]);
                    return genBuildOutput(node, 65, width, ({
                                                                page,
                                                                startX,
                                                                startY
                                                            }) => {
                        //let prevY = a4Height - marginY + 5
                        let prevY = startY + 5
                        page.drawImage(image, {
                            x: startX,
                            y: prevY - imageHeight,
                            width: imageWidth,
                            height: imageHeight,
                        })
                        page.drawText(ucTitle, {
                            x: (startX + width) - textWidth,
                            y: prevY - textHeight,
                            size: config["font-size-heading"],
                            font: fontBold.current,
                            color: green
                        })
                        prevY -= (imageHeight + 8)
                        // page.drawText('Dead Easy Mortgages', {
                        //     x    : startX,
                        //     y    : prevY,
                        //     size : config["font-size-heading"],
                        //     font : fontNormal.current,
                        //     color: green
                        // });
                        // prevY -= 12
                        page.drawText('www.sussdmortgages.ie', {
                            x: startX,
                            y: prevY,
                            size: 8,
                            font: fontNormal.current,
                            color: config["text-color-light"]
                        });
                        prevY -= 10
                        page.drawText('help@sussd.ie', {
                            x: startX,
                            y: prevY,
                            size: 8,
                            font: fontNormal.current,
                            color: config["text-color-light"]
                        });
                    })
                },
                kevinSignature: async () => {
                    const pngImageBytes = await fetch(kevinSignature).then(res => res.arrayBuffer());
                    const image = await pdfDoc.current.embedPng(pngImageBytes);
                    const {
                        width: imageWidth,
                        height: imageHeight
                    } = image.scale(0.3);
                    return genBuildOutput(node, 10, width, ({
                                                                page,
                                                                startX,
                                                                startY
                                                            }) => {
                        page.drawImage(image, {
                            x: startX,
                            y: startY - imageHeight,
                            width: imageWidth,
                            height: imageHeight,
                        })
                    })
                },
                border: async () => {
                    let h = localProps.height ? localProps.height : config["hr-height"]
                    let c = config["hr-color"]
                    if (localProps.color) {
                        c = config.colors[localProps.color]
                    }
                    return genBuildOutput(node, h, width, ({
                                                               page,
                                                               startX,
                                                               startY
                                                           }) => {
                        page.drawRectangle({
                            x: startX,
                            y: startY - h,
                            width: width,
                            height: h,
                            color: c,
                            borderWidth: 0
                        })
                    })
                },
                container: async () => {
                    let [paddingLeft, paddingRight, paddingTop, paddingBottom] = getLocalPadding('padding', 0, 0)

                    let vAlign = localProps["v-align"] ? localProps["v-align"] : "top"
                    let bgColorName = localProps["bg-color"] ? localProps["bg-color"] : false
                    let bgColor = bgColorName ? config.backgroundColors[bgColorName] : false
                    let contentWidth = width - (paddingLeft + paddingRight)
                    if (typeof node.children === "string") {
                        node.children = [node.children]

                    }
                    let partsPromises = node.children.map(item => buildComponent(item, {width: contentWidth}))
                    let result = (await Promise.all(partsPromises)).filter(v => !!v)
                    let contentHeight = result.reduce((acc, item) => acc + item.height, 0)
                    let height = contentHeight + paddingTop + paddingBottom
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        if (bgColor) {
                            page.drawRectangle({
                                x: startX,
                                y: startY - height,
                                width,
                                height: height,
                                color: bgColor,
                                borderWidth: 0,
                            })
                        }
                        result.forEach(item => {
                            item.draw({
                                page,
                                startX: startX + paddingLeft,
                                startY: startY - paddingTop
                            })
                            startY -= item.height
                        })
                    })
                },
                bullet: async () => {
                    let bulletSpacing = localProps["offset"] ? localProps["offset"] : config["bullet-spacing"]
                    let bulletSize = localProps["bullet-size"] || localProps["size"] || 1
                    let bulletColor = localProps['bullet-color'] ? config.colors[localProps['bullet-color']] : localProps["color"] ? localProps["color"] : config["text-color-default"]
                    let {dot, offset, color, ...rest} = localProps

                    let textNode = {
                        type: "CONTAINER",
                        props: {
                            "padding-left": bulletSpacing,
                        },
                        children: node.children
                    }
                    const {
                        height,
                        draw
                    } = await buildComponent(textNode, {width})

                    let customDotDraw
                    if (localProps.dot) {
                        let dotNode = {
                            "type": "CONTAINER",
                            "props": {},
                            "children": [
                                {
                                    type: "STRING",
                                    props: {
                                        ...localProps,
                                        "font-weight": 'bold',
                                        "padding-left": 0
                                    },
                                    children: [localProps.dot.toString()]
                                }
                            ]
                        }
                        let {
                            height: dotHeight,
                            draw: customDotDrawFunction
                        } = await buildComponent(dotNode, {width})
                        customDotDraw = customDotDrawFunction
                    }
                    let bulletHeight = 4 * bulletSize
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        draw({
                            page,
                            startX,
                            startY
                        })
                        if (localProps.dot) {
                            customDotDraw({
                                page,
                                startX,
                                startY
                            })
                        } else {
                            page.drawSvgPath(bulletPath, {
                                x: startX,
                                y: startY - 5,
                                color: bulletColor,
                                scale: bulletSize
                            })
                        }

                    })

                    // let fontSize = localProps["font-size"] ? localProps["font-size"] : config["font-size-default"]
                    // let scale = localProps["scale"] ? localProps["scale"] : 1
                    // let bulletColumnWidth = localProps["bullet-spacing"] ? localProps["bullet-spacing"] : config["bullet-spacing"]
                    // let restColumnWidth = width - bulletColumnWidth
                    // let font = localProps.fontWeight === "bold" ? fontBold.current : fontNormal.current
                    //
                    // const {
                    //     lineHeight,
                    //     lines
                    // } = layoutMultilineText(node.children[0], {
                    //     fontSize,
                    //     font,
                    //     bounds: {width},
                    // })
                    // let cleanedLines = lines.filter(l => l.text !== '')
                    // let height = lineHeight * cleanedLines.length
                    //
                    //
                    // return genBuildOutput(node, fontSize * 1.5, width, ({
                    //     page,
                    //     startX,
                    //     startY
                    // }) => {
                    //     let bulletY = startY - (lineHeight / 2)
                    //     page.drawSvgPath(bulletPath, {
                    //         x    : startX,
                    //         y    : bulletY,
                    //         color: color,
                    //         scale: scale
                    //     })
                    //     let pointerY = startY
                    //     let customOffsetY = 3 * (lineHeight - fontSize) / 4
                    //     pointerY += customOffsetY
                    //     cleanedLines.forEach((line, i) => {
                    //         let contentWidth = font.widthOfTextAtSize(line.text, fontSize)
                    //         switch (align) {
                    //             case 'center':
                    //                 pointerX = (startX + (width / 2) - (contentWidth / 2))
                    //                 break
                    //             case 'right':
                    //                 pointerX = (startX + width) - contentWidth
                    //                 break
                    //             default:
                    //                 pointerX = startX
                    //         }
                    //         // let randomColors = Object.keys(config.backgroundColors)
                    //         // let randomIndex = Math.floor(Math.random() * randomColors.length)
                    //         //     page.drawRectangle(
                    //         //         {
                    //         //             x          : pointerX,
                    //         //             y          : pointerY - customOffsetY,
                    //         //             width      : width,
                    //         //             height     : lineHeight,
                    //         //             color      : config.backgroundColors[randomColors[randomIndex]],
                    //         //             borderWidth: 0
                    //         //         }
                    //         //     )
                    //         page.drawText(line.text, {
                    //             x   : startX + bulletColumnWidth,
                    //             y   : pointerY,
                    //             size: fontSize,
                    //             lineHeight,
                    //             font: font,
                    //             color,
                    //         })
                    //         pointerY -= lineHeight
                    //     })
                    // })
                    // let cell1 = gridCell({type: 'bullet'}, props)
                    // let cell2 = gridCell(content, {
                    //     ...props,
                    //     width: restColumnWidth
                    // })
                    //
                    // let builtCellsPromises = [
                    //     cell1,
                    //     cell2
                    // ].map((cell, i) => {
                    //     return buildContent(cell)
                    // })
                    // let builtCells = await Promise.all(builtCellsPromises)
                    //
                    // let rowHeight = 0
                    // builtCells.forEach(cell => {
                    //     rowHeight = Math.max(rowHeight, cell.height)
                    // })
                    // return {
                    //     height: rowHeight,
                    //     draw  : ({
                    //         page,
                    //         startX,
                    //         startY
                    //     }) => {
                    //         //TODO: depreciate gridInGrid
                    //         let rowXCursor = startX
                    //         builtCells.forEach((cell, i) => {
                    //             const {draw} = cell
                    //             draw({
                    //                 page,
                    //                 startX: rowXCursor,
                    //                 startY,
                    //                 height: rowHeight
                    //             })
                    //             rowXCursor += bulletColumnWidth
                    //         })
                    //     }
                    // }
                    //
                    // let bulletSize = fontSize * 0.5
                    // let lineHeight = fontSize * 1.5
                    // let text = node.children[0]
                    // let textWidth = fontNormal.current.widthOfTextAtSize(text, fontSize)
                    // let textHeight = fontNormal.current.heightAtSize(fontSize)
                    // let bulletX = 0
                    // let bulletY = 0
                    // let bulletPath = dot === 'check' ? tickPath : uncheckedPath
                    // return {
                    //     height: lineHeight,
                    //     draw  : ({
                    //         page,
                    //         startX,
                    //         startY
                    //     }) => {
                    //         bulletY = startY - (lineHeight / 2)
                    //         bulletX = startX
                    //         page.drawSvgPath(bulletPath, {
                    //             x    : bulletX,
                    //             y    : bulletY,
                    //             color: color,
                    //             scale: bulletSize
                    //         })
                    //         page.drawText(text, {
                    //             x    : bulletX + bulletSize + 5,
                    //             y    : bulletY - (textHeight / 2),
                    //             size : fontSize,
                    //             font : fontNormal.current,
                    //             color: color
                    //         })
                    //     }
                    // }
                },
                row: async () => {

                    localProps["grid-columns"] = props.columns
                    let [paddingLeft, paddingRight, paddingTop, paddingBottom] = props.cellPadding
                    node.children.forEach((child, i) => {
                        if (!child.props.hasOwnProperty("padding-left")) {
                            child.props["padding-left"] = paddingLeft
                        }
                        if (!child.props.hasOwnProperty("padding-right")) {
                            child.props["padding-right"] = paddingRight
                        }
                        if (!child.props.hasOwnProperty("padding-top")) {
                            child.props["padding-top"] = paddingTop
                        }
                        if (!child.props.hasOwnProperty("padding-bottom")) {
                            child.props["padding-bottom"] = paddingBottom
                        }
                    })

                    let {
                        height,
                        draw
                    } = await builders.childrenAcross()
                    let bgColor = localProps["bg-color"] ? config.backgroundColors[localProps["bg-color"]] : false
                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        if (bgColor) {
                            page.drawRectangle({
                                x: startX,
                                y: startY - height,
                                width,
                                height: height,
                                color: bgColor,
                                borderWidth: 0,
                            })
                        }
                        draw({
                            page,
                            startX,
                            startY,
                            availableHeight: height
                        })
                    })
                },
                gridChildren: async () => {
                    // row factory
                    let vBars = localProps["vertical-bars"] ? localProps["vertical-bars"] : false
                    let hBars = localProps["horizontal-bars"] ? localProps["horizontal-bars"] : false
                    let [left, right, top, bottom] = getLocalPadding('cell-padding', config["grid-cell-padding-x"], config["grid-cell-padding-y"])

                    let cellPadding = [left, right, top, bottom]
                    let columns = [24]
                    if (localProps["columns"]) {
                        if (typeof localProps["columns"] === "string") {
                            columns = localProps["columns"].split(/[^0-9.]+/).map(c => parseFloat(c))
                        }
                        if (Array.isArray(localProps["columns"])) {
                            columns = localProps["columns"]
                        }
                    }

                    // will build a row
                    let partsPromises = node.children.map((item, i) => buildComponent(item, {
                        width,
                        columns,
                        cellPadding
                    }))
                    let result = (await Promise.all(partsPromises)).filter(v => !!v)

                    let height = result.reduce((acc, item) => acc + item.height, 0)

                    let thickness = 0.5


                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        let pointerY = startY
                        result.forEach(item => {
                            item.draw({
                                page,
                                startX,
                                startY: pointerY
                            })
                            pointerY -= item.height
                        })
                        if (vBars) {
                            let pointerX = startX
                            // draw bars across
                            if (["both", "outside"].includes(vBars)) {
                                page.drawLine({
                                    start: {x: pointerX + (thickness / 2), y: startY},
                                    end: {x: pointerX + (thickness / 2), y: startY - height},
                                    thickness,
                                    color: config["grid-border-color"]
                                })
                            }
                            columns.forEach((c, i) => {
                                let lastCol = i === columns.length - 1
                                let finalCellAdjustment = lastCol ? thickness / 2 : 0
                                pointerX += (c / 24) * width

                                if ((vBars === "inside" && !lastCol) || vBars === "both" || (vBars === "outside" && lastCol)) {
                                    page.drawLine({
                                        start: {
                                            x: pointerX - finalCellAdjustment,
                                            y: startY
                                        },
                                        end: {
                                            x: pointerX - finalCellAdjustment,
                                            y: startY - height
                                        },
                                        thickness: 0.5,
                                        color: config["grid-border-color"]
                                    })
                                }

                            })
                        }
                        if (hBars) {
                            let pointerY = startY
                            if (["both","outside"].includes(hBars)) {
                                page.drawLine({
                                    start: {x: startX, y: pointerY - (thickness / 2)},
                                    end: {x: startX + width, y: pointerY - (thickness / 2)},
                                    thickness,
                                    color: config["grid-border-color"]
                                })
                            }
                            result.forEach((item, i) => {
                                pointerY -= item.height
                                let lastRow = i === result.length - 1
                               if ((hBars === "inside" && !lastRow) || hBars === "both" || (hBars === "outside" && lastRow)) {
                                    page.drawLine({
                                        start: {x: startX, y: pointerY + (thickness / 2)},
                                        end: {x: startX + width, y: pointerY + (thickness / 2)},
                                        thickness,
                                        color: config["grid-border-color"]
                                    })
                                }
                            })
                        }
                    })
                },
                grid: async () => {
                    let {
                        height,
                        draw
                    } = await builders.gridChildren() // build rows in downward direction

                    return genBuildOutput(node, height, width, ({
                                                                    page,
                                                                    startX,
                                                                    startY
                                                                }) => {
                        draw({
                            page,
                            startX,
                            startY
                        })
                    })
                },
                gap: async () => {
                    let size = localProps.size || 10
                    return genBuildOutput(node, size, width, () => {
                    })
                }
            }

            if (!node.type){
                if (typeof node !== "string") {

                    throw new Error('Node type must be a string')
                }
            }
            if (typeof node === "string") {
                node = {
                    children: [node]
                }
                return await builders.textBlock()
            }

            switch (node.type.toLowerCase()) {
                case 'radio':
                    return await builders.radio()
                case 'dropdown':
                    return await builders.dropdown()
                case 'checkbox':
                    return await builders.checkbox()
                case 'textfield':
                    return await builders.textfield()
                case 'kevinsignature':
                    return await builders.kevinSignature()
                case 'group':
                    return await builders.group()
                case 'sentence':
                    return await builders.sentence()
                case 'gap':
                    return await builders.gap()
                case 'string':
                    return builders.textBlock()
                case 'header':
                    return await builders.header()
                case 'border':
                    return await builders.border()
                case 'container':
                    return await builders.container()
                case 'bullet':
                    return await builders.bullet()
                case 'grid':
                    return await builders.grid()
                // return buildGrid(children, props)
                case 'row':
                    return await builders.row()
                case 'cell':
                    return await builders.container()
                //return buildCell(children, props)
                case 'p':
                    localProps["padding-y"] = localProps["padding-y"] && localProps["padding-y"] !== 0 ? localProps["padding-y"] : config["paragraph-padding-y"]
                    return await builders.container()
                // return buildBullet(children, props)
                default:
                    return null
            }

        }

        async function addFooter(page) {
            let fontSize = 7
            let color = config["text-color-light"]
            let width = a4Width
            let font = fontNormal.current
            let string1 = 'Truss Mortgages Limited t/a Suss’d Mortgages, Company Registration Number 690100, is regulated by the Central Bank of Ireland'
            let string2 = 'Registered Address: 222 Harolds Cross Road, Dublin 6W. Director: Kevin Coakley'
            let content1Width = font.widthOfTextAtSize(string1, fontSize)
            let content2Width = font.widthOfTextAtSize(string2, fontSize)
            let pointer1X = (startX + (width / 2) - (content1Width / 2))
            let pointer2X = (startX + (width / 2) - (content2Width / 2))
            let pointer1Y = 14
            let pointer2Y = 5
            page.drawText(string1, {
                x: pointer1X,
                y: pointer1Y,
                size: fontSize,
                font: font,
                color,
            })
            page.drawText(string2, {
                x: pointer2X,
                y: pointer2Y,
                size: fontSize,
                font: font,
                color,
            })
        }

        let pageComponents = (await Promise.all(components.map(item => buildComponent(item, props)))).filter(v => !!v)

        let totalHeight = pageComponents.reduce((acc, component) => acc + component.height, 0) + (2 * config["page-margin-y"])

        totalHeight += (pageComponents.length - 1) * groupGap

        let startX = config["page-margin-x"]
        if (height === "infinite") {

            let startY = totalHeight - config["page-margin-y"]
            const pageInfinite = pdfDoc.current.addPage([
                a4Width,
                totalHeight
            ]);
            pageComponents.forEach(component => {
                component.draw({
                    page: pageInfinite,
                    startY,
                    startX
                })
                startY -= component.height + groupGap
            })
            await addFooter(pageInfinite)


        } else {

            const newPage = () => {
                let pg = pdfDoc.current.addPage([
                    a4Width,
                    a4Height
                ])
                addFooter(pg)
                return pg
            }
            let startY = a4Height - config["page-margin-y"]
            let maxHeight = a4Height - (2 * config["page-margin-y"])

            while (pageComponents.length) {
                let page = newPage();
                let myY = startY
                let currentPageGroupsHeight = 0
                while (pageComponents.length) {
                    let nextComponent = pageComponents[0]
                    let spaceNeeded = groupGap + nextComponent.height
                    // if space available add the group to the page and remove it from the list of pageComponents
                    if (currentPageGroupsHeight + spaceNeeded < maxHeight) {

                        let currentComponent = pageComponents.shift()
                        currentComponent.draw({
                            page,
                            startY: myY,
                            startX
                        })
                        currentPageGroupsHeight += spaceNeeded
                        myY -= spaceNeeded
                    } else {

                        break
                    }
                }
            }
        }
    }

    useEffect(() => {
        return () => {
            pdfDoc.current = null
            pdfForm.current = null
            fontBold.current = null
            fontNormal.current = null
        }
    }, []);

    return {
        initialise,
        ready,
        open,
        test,
        save,
    }
}